<template>
  <div class="home">
    <div style="padding: 0.5rem 2rem; width:70%;">
      <p style="font-size:1.1rem;">
        Enter each card's three-letter ID.
        <br />Tap any result for further context.
      </p>
    </div>
    <origin-list :cards="cards" :editing="editing"></origin-list>

    <button @click="submit" class="button submit" v-if="editing">CHALLENGE</button>
    <button @click="clearGame" class="button reset" v-else>RESET</button>
  </div>
</template>

<script>
  import OriginList from '@/components/OriginList'
  import { mapState, mapActions, mapMutations } from 'vuex'

  export default {
    name: 'home',
    components: { OriginList },
    data: function() {
      return {
        editing: true
      }
    },
    computed: {
      ...mapState(['cards'])
    },
    methods: {
      ...mapActions(['getCards', 'determineWinner']),
      ...mapMutations({ reset: 'RESET' }),
      submit() {
        // Check to make sure that we have enough IDs to submit an Origin Point Request
        if (this.cards.filter(c => c.id).length < 2) {
          alert('You need more than one person to play!')
        } else {
          this.getCards(this.cards.map(c => c.id)).then(() => {
            this.determineWinner()
            this.editing = false
          })
        }
      },
      clearGame() {
        this.reset()
        this.editing = true
      }
    }
  }
</script>
<style lang="less">
  .button {
    padding: 1.2rem;
    color: white;
    font-weight: bold;
    font-size: 2rem;
    border: none;
    border-radius: 3px;
    margin-left: 2rem;
    cursor: pointer;
  }
  .submit {
    background: #e84100;
    border-left: 4px solid #b83000;
    border-right: 4px solid #b83000;
    border-bottom: 8px solid #b83000;
  }
  .reset {
    background: #303636;
    border-left: 4px solid #000000;
    border-right: 4px solid #000000;
    border-bottom: 8px solid #000000;
  }
</style>
